module.exports = __webpack_public_path__ + "static/media/self-compassion.95f9e032.svg";